export default __webpack_public_path__ + "static/media/job-history-placeholder.15960cd0.png";